import "./App.css";
import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { ProductProvider } from "./context/ProductContext";

const Home = lazy(() => import("./component/Home"));
const Feedback = lazy(() => import("./Feedback"));
const AboutUs = lazy(() => import("./link/AboutUs.jsx"));
const PrivacyPolicy = lazy(() => import("./link/PrivacyPolicy.jsx"));
const RefundReturn = lazy(() => import("./link/RefundReturn.jsx"));
const Guide = lazy(() => import("./link/Guide.jsx"));
const GuideArticle = lazy(() => import("./link/GuideArticle.jsx"));
const Sitemap = lazy(() => import("./link/Sitemap.jsx"));
const TermCondition = lazy(() => import("./link/TermCondition.jsx"));
const Contact = lazy(() => import("./link/Contact.jsx"));
const NotFound = lazy(() => import("./link/NotFound.jsx"));
const AlterationAndTailoring = lazy(
  () => import("./services/AlterationAndTailoring.jsx"),
);
const Bridal = lazy(() => import("./services/Bridal.jsx"));
const Gown = lazy(() => import("./services/Gown.jsx"));
const Jalabiya = lazy(() => import("./services/Jalabiya.jsx"));
const Kaftan = lazy(() => import("./services/Kaftan.jsx"));
const Maghribi = lazy(() => import("./services/Maghribi.jsx"));
const MaxiDresses = lazy(() => import("./services/MaxiDresses.jsx"));
const Mukhawar = lazy(() => import("./services/Mukhawar.jsx"));
const Soube = lazy(() => import("./services/Soube.jsx"));
const FashionWear = lazy(() => import("./services/FashionWear.jsx"));
const Embroidery = lazy(() => import("./services/Embroidery.jsx"));

function PageLoader() {
  return (
    <div className="page-loader">
      <span className="page-loader-spinner" />
    </div>
  );
}

function App() {
  return (
    <ProductProvider>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-return" element={<RefundReturn />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/guides/:slug" element={<GuideArticle />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/term-condition" element={<TermCondition />} />
          <Route path="/contact" element={<Contact />} />
          <Route
            path="/alteration-tailoring"
            element={<AlterationAndTailoring />}
          />
          <Route path="/bridal" element={<Bridal />} />
          <Route path="/gown" element={<Gown />} />
          <Route path="/jalabiya" element={<Jalabiya />} />
          <Route path="/kaftan" element={<Kaftan />} />
          <Route path="/maghribi" element={<Maghribi />} />
          <Route path="/maxi-dresses" element={<MaxiDresses />} />
          <Route path="/mukhawar" element={<Mukhawar />} />
          <Route path="/soube" element={<Soube />} />
          <Route path="/fashion-wear" element={<FashionWear />} />
          <Route path="/embroidery" element={<Embroidery />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </ProductProvider>
  );
}

export default App;
